import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-youtube-channel-insights-checklist',
  templateUrl: './help-youtube-channel-insights-checklist.component.html'
})
export class HelpYoutubeChannelInsightsChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
